<template>
  <div class="serv-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input v-model="searchParams.servNameLike" :placeholder="$t('housekeeping.serviceNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%" class="margin-top">
      <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
      <el-table-column prop="servId" label="服务编号" align="center"></el-table-column>
      <el-table-column prop="servName" label="服务名称" align="center"></el-table-column>
      <el-table-column prop="hktName" label="服务类型" align="center"></el-table-column>
      <el-table-column prop="repairWay" label="派单方式" align="center">
        <template #default="scope">
          <span v-if="scope.row.repairWay === '100'">抢单</span>
          <span v-else-if="scope.row.repairWay === '200'">指派</span>
          <span v-else-if="scope.row.repairWay === '300'">轮训</span>
        </template>
      </el-table-column>
      <el-table-column prop="returnVisitFlag" label="回访方式" align="center">
        <template #default="scope">
          <span v-if="scope.row.returnVisitFlag === '001'">都不回访</span>
          <span v-else-if="scope.row.returnVisitFlag === '002'">已评价不回访</span>
          <span v-else-if="scope.row.returnVisitFlag === '003'">都回访</span>
        </template>
      </el-table-column>
      <el-table-column prop="sales" label="销量" align="center"></el-table-column>
      <el-table-column prop="defaultFee" label="默认费用" align="center"></el-table-column>
      <el-table-column prop="sort" label="排序" align="center"></el-table-column>
      <el-table-column prop="state" label="上架状态" align="center">
        <template #default="scope">
          {{ scope.row.state === '1001' ? '未上架' : '上架' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button size="small" @click="handleViewDetail(scope.row)">
            {{ $t('common.view') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { getServList } from '@/api/housekeeping/housekeepingApi'

export default {
  name: 'AShopDetailServ',

  data() {
    return {
      searchParams: {
        servNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {

  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          servNameLike: this.searchParams.servNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await getServList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取服务列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleViewDetail(serv) {
      this.$emit('view-detail', serv)
    }
  }
}
</script>

<style scoped>
.serv-container {
}

.search-row {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}
</style>